import { EditorState, convertFromRaw } from "draft-js";
import BaseCommand from "./baseCommand";

class FormFieldCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
  }

  execute() {
    const { payload } = this.componentData;
    const { doctype } = payload;
    const { type, updateFromComponent } = payload;
    let preventFormFieldUpdateInSection = false;
    if (type === "CLAUSE" && updateFromComponent) {
      preventFormFieldUpdateInSection = true;
      this.componentData.payload.updateFromComponent = false;
    }
    if (doctype && doctype === "MASTERDOC") {
      const {
        updateDynamicFieldsInMasterDoc,
        forceUpdateLocalEditorState,
        updateEditorStateInSectionForClauseOptions,
      } = this.componentData;
      const { id, value, section } = payload;
      if (
        type === "CLAUSE" &&
        !updateFromComponent &&
        !payload.clauseOptionDetails
      ) {
        let editorState;
        if (value.value === null) {
          editorState.EditorState.createEmpty();
        } else {
          const draftState = convertFromRaw(JSON.parse(value.value));
          editorState = EditorState.createWithContent(draftState);
        }
        forceUpdateLocalEditorState({
          componentId: section.id,
          editorState,
        });
      } else if (
        type === "CLAUSE" &&
        !updateFromComponent &&
        payload.clauseOptionDetails
      ) {
        updateEditorStateInSectionForClauseOptions(
          payload.clauseOptionDetails,
          payload.componentId,
        );
      }
      updateDynamicFieldsInMasterDoc(
        id,
        value,
        preventFormFieldUpdateInSection,
      );
    } else {
      const {
        updateDynamicFieldsInDoc,
        forceUpdateLocalEditorState,
        updateEditorStateInSectionForClauseOptions,
      } = this.componentData;
      const { id, value, isShared, sharingHash, fillerType, section } = payload;
      if (
        type === "CLAUSE" &&
        !updateFromComponent &&
        !payload.clauseOptionDetails
      ) {
        let editorState;
        if (value.value === null) {
          editorState = EditorState.createEmpty();
        } else {
          const draftState = convertFromRaw(JSON.parse(value.value));
          editorState = EditorState.createWithContent(draftState);
        }
        forceUpdateLocalEditorState({
          componentId: section.id,
          editorState,
        });
      } else if (
        type === "CLAUSE" &&
        !updateFromComponent &&
        payload.clauseOptionDetails
      ) {
        updateEditorStateInSectionForClauseOptions(
          payload.clauseOptionDetails,
          payload.componentId,
        );
      }
      updateDynamicFieldsInDoc(
        id,
        value,
        isShared,
        sharingHash,
        fillerType,
        preventFormFieldUpdateInSection,
      );
    }
  }

  undo() {
    const { payload } = this.componentData;
    const { doctype } = payload;
    if (doctype && doctype === "MASTERDOC") {
      const {
        updateDynamicFieldsInMasterDoc,
        forceUpdateLocalEditorState,
        updateEditorStateInSectionForClauseOptions,
      } = this.componentData;
      const { id, oldValue: value, type, section } = payload;
      let updateValue = value;
      if (type === "AMOUNT" || type === "DATE") {
        if (value.val) updateValue = value.val;
        else updateValue = null;
      } else if (type === "PERIOD") {
        if (typeof value === "object" && value !== null) {
          if (value.periodUom === "" && value.periodValue === "") {
            updateValue = null;
          }
        }
      } else if (type === "RATE") {
        updateValue = { ...value, rateValue: null };
      } else if (type === "CLAUSE" && !payload.clauseOptionDetails) {
        let editorState;
        if (value.value === null) {
          editorState = EditorState.createEmpty();
        } else {
          const draftState = convertFromRaw(JSON.parse(value.value));
          editorState = EditorState.createWithContent(draftState);
        }
        forceUpdateLocalEditorState({
          componentId: section.id,
          editorState,
        });
      } else if (type === "CLAUSE" && payload.clauseOptionDetails) {
        updateEditorStateInSectionForClauseOptions(
          {
            ...payload.clauseOptionDetails,
            value: updateValue,
            clauseOptionsDetails: {
              ...payload.clauseOptionDetails.clauseOptionsDetails,
              value: updateValue,
            },
          },
          payload.componentId,
        );
      }
      updateDynamicFieldsInMasterDoc(id, updateValue);
    } else {
      const {
        updateDynamicFieldsInDoc,
        forceUpdateLocalEditorState,
        updateEditorStateInSectionForClauseOptions,
      } = this.componentData;
      const {
        id,
        oldValue: value,
        isShared,
        sharingHash,
        fillerType,
        type,
        section,
      } = payload;
      let updateValue = value;
      if (type === "AMOUNT" || type === "DATE") {
        if (value.val) updateValue = value.val;
        else updateValue = null;
      } else if (type === "PERIOD") {
        if (typeof value === "object" && value !== null) {
          if (value.periodUom === "" && value.periodValue === "") {
            updateValue = null;
          }
        }
      } else if (type === "RATE") {
        updateValue = { ...value, rateValue: null };
      } else if (type === "CLAUSE" && !payload.clauseOptionDetails) {
        let editorState;
        if (value.value === null) {
          editorState = EditorState.createEmpty();
        } else {
          const draftState = convertFromRaw(JSON.parse(value.value));
          editorState = EditorState.createWithContent(draftState);
        }
        forceUpdateLocalEditorState({
          componentId: section.id,
          editorState,
        });
      } else if (type === "CLAUSE" && payload.clauseOptionDetails) {
        updateEditorStateInSectionForClauseOptions(
          {
            ...payload.clauseOptionDetails,
            value: updateValue,
            clauseOptionsDetails: {
              ...payload.clauseOptionDetails.clauseOptionsDetails,
              value: updateValue,
            },
          },
          payload.componentId,
        );
      }
      // if (payload && id) this.scrollIntoView(id);
      updateDynamicFieldsInDoc(
        id,
        updateValue,
        isShared,
        sharingHash,
        fillerType,
      );
    }
  }
}

export default FormFieldCommand;
